import AppHeader from "../../layout/AppHeader";
import OrderServicesList from "../../xpost/views/dashboard/prepost/OrderServicesList";
import OrderServices from "../../xpost/views/services/order.services/OrderServices.vue";
import OrderServicesDetails from "../../xpost/views/services/order.services/OrderServicesDetails.vue";
import AddObjectsToOrderService from "../../xpost/views/services/order.services/AddObjectsToOrderService.vue";

const OrderServicesRoutes = [
  {
    path: "/servicos/ordem",
    name: "orderservices",
    components: {
      header: AppHeader,
      default: OrderServicesList,
    },
  },
  {
    path: "/servicos/ordem/adicionar",
    name: "orderservicesadd",
    components: {
      header: AppHeader,
      default: OrderServices,
    },
  },
  {
    path: "/servicos/ordem/details/:id",
    name: "orderservicesdetails",
    components: {
      header: AppHeader,
      default: OrderServicesDetails,
    },
  },
  {
    path: "/servicos/ordem/add-objects/:id/:customer",
    name: "addobjectstoorderservice",
    components: {
      header: AppHeader,
      default: AddObjectsToOrderService,
    },
  },
];

export default OrderServicesRoutes;
